import { Switch } from '@mui/material';
import { IconInput } from '../Inputs';

function ProductCookingConfig(props) {
	const { handleInput, fields, isDisable } = props;
	return (
		<div className='flex flex-col gap-4'>
			<div className='flex items-center gap-2'>
				<label
					htmlFor='isCMSEnabled'
					className='text-[rgba(95,95,95,0.75)] w-[150px]'
				>
					Recipe Enabled
				</label>
				<Switch
					size='small'
					name='isCMSEnabled'
					checked={fields?.isCMSEnabled}
					onChange={handleInput}
					id='isCMSEnabled'
					color='primary'
					disable={isDisable}
				/>
			</div>
			<div className='flex gap-2 items-center'>
				<label
					htmlFor='isEnabled'
					className='text-[rgba(95,95,95,0.75)] w-[150px]'
				>
					Cooking Required
				</label>
				<Switch
					size='small'
					name='isEnabled'
					checked={fields?.isEnabled}
					onChange={handleInput}
					id='isEnabled'
					color='primary'
					disable={isDisable}
				/>
			</div>
			<div className='flex gap-2 items-center'>
				<label
					htmlFor='time'
					className='text-[rgba(95,95,95,0.75)] w-[150px]'
				>
					Time
				</label>
				<IconInput
					size='medium'
					type='custom'
					iconText='min'
					name='timeReq'
					id='timeReq'
					handleInput={handleInput}
					value={fields?.timeReq}
					dataAttrs={{
						required: true,
						min: 1,
					}}
					isDisable={isDisable}
				/>
			</div>
		</div>

	);
}
export default ProductCookingConfig;
